import { Helmet } from "react-helmet-async";
import { useLang } from "@/i18n/lang";

const ORIGIN = "https://werkverdung.com";
const DEFAULT_IMAGE = `${ORIGIN}/og-image.jpg`;

// Per-page SEO. Backward compatible: existing pages pass title/description/path
// only. New SEO landing pages additionally pass an explicit `lang`, per-page
// `image`, `type`, hreflang `alternates` and optional `jsonLd` structured data.
// Site-level OG/Twitter defaults also live in public/index.html so non-JS social
// scrapers (WhatsApp, Facebook) always get a preview; Google uses the rendered
// (Helmet) values below.
export const Seo = ({
  title,
  description,
  path = "",
  lang: langOverride,
  image = DEFAULT_IMAGE,
  type = "website",
  alternates,
  jsonLd,
}) => {
  const { lang: ctxLang } = useLang();
  const lang = langOverride || ctxLang;
  const url = `${ORIGIN}${path}`;
  return (
    <Helmet>
      <html lang={lang} />
      <title>{title}</title>
      <meta name="description" content={description} />
      <link rel="canonical" href={url} />

      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:url" content={url} />
      <meta property="og:type" content={type} />
      <meta property="og:image" content={image} />

      <meta name="twitter:title" content={title} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={image} />

      {alternates?.map((a) => (
        <link key={a.hrefLang} rel="alternate" hrefLang={a.hrefLang} href={a.href} />
      ))}

      {jsonLd && (
        <script type="application/ld+json">{JSON.stringify(jsonLd)}</script>
      )}
    </Helmet>
  );
};

export { ORIGIN };
export default Seo;
